import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { SecondaryShareKeyVM } from '~src/types/db';
import {
  loadSecondaryShareKeys,
  LoadSecondaryShareKeysParams,
} from '~src/services/api/secondaryVendors';
import { QueryKeys } from './queryKeys';

/**
 * Primary-/Secondary Share Keys: list secondary share keys under a given
 * primary share key. Mirrors useTenderSharesList.ts's shape.
 */
export const useSecondaryShareKeys = (
  params: LoadSecondaryShareKeysParams,
  queryConfig: QueryConfig<SecondaryShareKeyVM[], AxiosError> = {}
) => {
  return useQuery<SecondaryShareKeyVM[], AxiosError>(
    [QueryKeys.secondaryShareKeys, params.shareId, params.shareKey],
    () => loadSecondaryShareKeys(params),
    {
      enabled: !!params.shareId && !!params.shareKey,
      refetchOnWindowFocus: false,
      ...queryConfig,
    }
  );
};
